export default {
    label: 'Select State',
    label_screen_reader: 'Select your state',
    label_native: 'Your State',
};
